import React from 'react'
import styled from 'styled-components'
import { Link } from '../../components/Link'
import { TopNavLinkList } from './TopNavLinkList'
import { TopNavRight } from './TopNavRight'
import { AroundSchoolsLogo } from '../Image/AroundSchoolsLogo'
import { TopNavColor } from './TopNav.types'
import { SCREEN_SIZE, STYLES } from '../../static/style'

type TopNavWithoutSearchBarProps = {
  color?: TopNavColor
  className?: string
  onShowSearchBar: () => void
}

const StyledTopNavWithoutSearch = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding: 0.25rem 1rem;
  height: 100%;
  ${({ color }: { color: TopNavColor }) =>
    ({
      [TopNavColor.NORMAL]: `background-color: ${STYLES.COLOR_OUTER_SPACE_GRAY};`,
      [TopNavColor.GRAY]: `background-color: ${STYLES.PRIMARY_COLOR};`,
    }[color])}
  ${SCREEN_SIZE.MD} {
    padding: 0.5rem 2rem;
  }
`

const TopNavWithoutSearchBar = ({
  color = TopNavColor.NORMAL,
  className,
  onShowSearchBar,
}: TopNavWithoutSearchBarProps) => (
  <StyledTopNavWithoutSearch color={color} className={className}>
    <Link to="/">
      <AroundSchoolsLogo isGray={color === TopNavColor.GRAY} />
    </Link>
    <TopNavLinkList color={color} />
    <TopNavRight
      color={color}
      loginText="Sign up / Login"
      isShowSearchIcon
      onSearchIconClick={onShowSearchBar}
    />
  </StyledTopNavWithoutSearch>
)

export default TopNavWithoutSearchBar
